"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartnershipTexts = void 0;
var usePartnershipTexts_hook_1 = require("./usePartnershipTexts.hook");
Object.defineProperty(exports, "usePartnershipTexts", { enumerable: true, get: function () { return usePartnershipTexts_hook_1.usePartnershipTexts; } });
//# sourceMappingURL=index.js.map